import { compressToEncodedURIComponent, decompressFromEncodedURIComponent } from "lz-string";

export const decompress = (text: string): string => {
  return decompressFromEncodedURIComponent(text);
};

export const compress = (text: string): string => {
  return compressToEncodedURIComponent(text);
};
